<ng-template #sidebarMenuItems>
  <core-collapsible-menu
    [id]="collapsibleMenus[0].id"
    title="Motor de decisión"
    [isOpen]="collapsibleMenus[0].isOpen"
    [collapsed]="siderCollapsed"
    (activeMenuEvent)="accordionBehavior($event)"
  >
    <fa-icon menu-icon [icon]="['fas','engine']" class="sidebar-menu-icon"></fa-icon>
    <div menu-content>
      <a class="sidebar-subitem" routerLink="/inicio/motor-de-decision" routerLinkActive="sidebar-subitem--active">
        Listado de motores de decisión
      </a>
      <a class="sidebar-subitem" routerLink="/inicio/motor-de-decision/nuevo-motor" routerLinkActive="sidebar-subitem--active">
        Nuevo motor de decisión
      </a>
    </div>
  </core-collapsible-menu>

  <core-collapsible-menu
    [id]="collapsibleMenus[1].id"
    title="Análisis avanzado"
    [isOpen]="collapsibleMenus[1].isOpen"
    [collapsed]="siderCollapsed"
    (activeMenuEvent)="accordionBehavior($event)"
  >
    <fa-icon menu-icon [icon]="['fas','magnifying-glass-waveform']" class="sidebar-menu-icon"></fa-icon>
    <div menu-content>
      <a class="sidebar-subitem" routerLink="/inicio/analisis-de-credito" routerLinkActive="sidebar-subitem--active">
        Listado de análisis avanzado
      </a>
    </div>
  </core-collapsible-menu>

  <core-collapsible-menu
    *appHasPermission="'crosscore:read'"
    [id]="collapsibleMenus[2].id"
    title="Validación de identidad"
    [isOpen]="collapsibleMenus[2].isOpen"
    [collapsed]="siderCollapsed"
    (activeMenuEvent)="accordionBehavior($event)"
  >
    <fa-icon menu-icon [icon]="['fas','shield-check']" class="sidebar-menu-icon"></fa-icon>
    <div menu-content>
      <a class="sidebar-subitem" routerLink="/inicio/validacion-de-identidad" routerLinkActive="sidebar-subitem--active">
        Listado de validaciones
      </a>
    </div>
  </core-collapsible-menu>
</ng-template>

<ng-template #sidebarUserMenu let-collapsed="collapsed">
  <core-collapsible-menu
    [id]="collapsibleMenus[3].id"
    [title]="userData.name || 'Usuario'"
    [isOpen]="collapsibleMenus[3].isOpen"
    [collapsed]="collapsed"
    (activeMenuEvent)="accordionBehavior($event)"
  >
    <span menu-icon class="sidebar-user-menu__avatar">{{ userData.initial || 'U' }}</span>
    <div menu-content>
      <button type="button" class="sidebar-subitem sidebar-subitem--action" (click)="onLogoutClick()">
        <fa-icon [icon]="['fal','person-from-portal']" class="sidebar-subitem__icon"></fa-icon>
        Cerrar sesión
      </button>
    </div>
  </core-collapsible-menu>
</ng-template>

<div class="layout-shell">
  <div
    class="layout-app"
    [class.layout-app--mobile-menu-open]="mobileMenuOpen"
    [class.layout-app--external]="permissionsSvc.isExternalAccess()">

    <header
      *ngIf="!permissionsSvc.isExternalAccess()"
      class="layout-mobile-header">
      <button
        type="button"
        class="layout-mobile-header__action"
        (click)="toggleMobileMenu()"
        aria-label="Abrir menú">
        <fa-icon [icon]="['fal', 'bars']"></fa-icon>
      </button>

      <img
        src="/assets/images/corefluens/LOGIDEC.png"
        alt="Logidec"
        class="layout-mobile-header__logo"
      />

      <span class="layout-mobile-header__spacer" aria-hidden="true"></span>
    </header>

    <div class="layout-app__body">
      <nz-layout class="layout-app__row">
        <nz-sider
          *ngIf="!permissionsSvc.isExternalAccess()"
          class="app-sider app-sider--desktop hide-scroollbar"
          [nzTrigger]="null"
          nzCollapsible
          [nzCollapsed]="siderCollapsed"
          [nzWidth]="240"
          [nzCollapsedWidth]="57"
        >
          <div class="app-sider__shell">
            <div class="app-sider__body" (click)="onSidebarNavClick($event)">
              <div class="app-sider__logo">
                <img
                  [src]="collapse ? '/assets/images/corefluens/Logo_Logidec.png' : '/assets/images/corefluens/LOGIDEC_2.png'"
                  [alt]="collapse ? 'Logidec' : 'Logo Logidec'"
                  class="app-sider__logo-image"
                  [class.app-sider__logo-image--collapsed]="collapse"
                />
              </div>

              <nav class="app-sider__nav">
                <ng-container *ngTemplateOutlet="sidebarMenuItems"></ng-container>
              </nav>
            </div>

            <div class="app-sider__footer">
              <div class="app-sider__user-menu">
                <ng-container *ngTemplateOutlet="sidebarUserMenu; context: { collapsed: siderCollapsed }"></ng-container>
              </div>

              <button type="button" class="app-sider__collapse-btn" (click)="toggleSidebar()">
                <fa-icon
                  [icon]="['fal', collapse ? 'chevrons-right' : 'chevrons-left']"
                  class="app-sider__collapse-icon">
                </fa-icon>
                <span class="app-sider__collapse-label">Colapsar menú</span>
              </button>
            </div>
          </div>
        </nz-sider>

        <nz-layout class="layout-main">
          <div
            class="layout-main__content"
            cdkScrollable
            [@fadeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''"
            updateOnScroll>
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        </nz-layout>
      </nz-layout>
    </div>

    <aside
      *ngIf="mobileMenuOpen && !permissionsSvc.isExternalAccess()"
      class="layout-mobile-drawer"
      aria-label="Menú de navegación"
      (click)="onSidebarNavClick($event)">
      <nav class="layout-mobile-drawer__nav">
        <ng-container *ngTemplateOutlet="sidebarMenuItems"></ng-container>
      </nav>

      <div class="layout-mobile-drawer__footer">
        <ng-container *ngTemplateOutlet="sidebarUserMenu; context: { collapsed: false }"></ng-container>
      </div>
    </aside>

    <button
      *ngIf="mobileMenuOpen && !permissionsSvc.isExternalAccess()"
      type="button"
      class="layout-mobile-backdrop"
      (click)="closeMobileMenu()"
      aria-label="Cerrar menú">
    </button>
  </div>
</div>

<ng-template #templateNotification>
  <div class="ant-notification-notice-content">
    <div class="ant-notification-notice-with-icon">
      <span class="ant-notification-notice-icon">
        <fa-icon [icon]="['fas','circle-exclamation']" class="text-danger text-16"> </fa-icon>
      </span>
      <div class="ant-notification-notice-description !ml-32 !text-14">
        Si no se detecta actividad en los próximos 5 minutos su sesión terminará.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #customCloseIcon class="custom-close-icon">
  <fa-icon [icon]="['fal','xmark']" class="text-danger text-20"> </fa-icon>
</ng-template>
